import React, { Component } from "react";
import ReactDOM from 'react-dom';
import Container from '@material-ui/core/Container';
import Grid from '@material-ui/core/Grid'
import Button from '@material-ui/core/Button'
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import AppBar from '@material-ui/core/AppBar';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import Typography from '@material-ui/core/Typography';
import Box from '@material-ui/core/Box';
import codeimage from '../img/2.png'
import Aimage from '../img/a.png'
import Dimage from '../img/d.png'





import './discussion.css'
function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box p={3}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}
TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired,
};
function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`,
  };
}

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    backgroundColor: theme.palette.background.paper,
  },
}));
const Discussionbody = () => {

  const classes = useStyles();
  const [value, setValue] = React.useState(0);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  return (
    <div className="pcc---slider py-5">
      <Container>
        <Grid
          container
          justify="center"
         
        >
          <Grid
            container
            justify="center"
            md={8}
            className="mt-5 py-md-5"
          >
            <h1 className="pcc---section-main-heading" >LITEPAPER</h1>
          </Grid>
          <Grid
            container
            justify="center"
            md={8}
            className=""
            style={{borderBottom:'1px solid black'}}


          >
            
            
              <p className="text-center">
              <img src={Aimage} className="img-fluid mb-3 left"  style={{width: '12%',display: 'block',
    marginLeft: 'auto'}} />
    

                <h4 className="pcc---section-main-heading">Token Distribution</h4>
                <div>
                <p>• 10,000,000,000 PCATV3. </p><br></br>

                <p>• 5000,000,000 for presale (Raising 100 BNB). </p><br></br>

                <p>• 14% to swap for pCATv2. </p><br></br>

                <p>• Swap tokens to v2 to be released after 2 hrs so no one dumps.</p><br></br>

                <p>• Remaining will go to liquidity. </p><br></br>

                <p>• The selling presale price is 50000000=1 BNB. </p><br></br>

                <p>• The listing price would be same as presale price. (Dont want presale guys to dump either). </p>

                <p>• 86% raised goes directly to liquidity.</p>

                <p>• (Cap of 2 BNB per wallet).</p>
                </div>
                <img src={Dimage} className="img-fluid mb-3 left"  style={{width: '12%',display: 'block',
    marginRight: 'auto'}} />
              </p>
              
              <Grid
                container
                direction="row"
                justify="center"
                md={11}
                className="mb-5"
              >
                <Grid
                  container
                  direction="row"
                  justify="center"
                xs={12}
                sm={8}
                // className="pcc---whitepapercard my-5 p-5"
                >
                  <img src={codeimage} className="img-fluid mb-3"  style={{width: '100%',height:"100%",maxWidth:'400px'}} />
                 
                </Grid>
              </Grid>
          </Grid>
          <Grid
            container
            justify="center"
            md={12}
            className="mt-5"
          >
            
              
              
          </Grid>
          <Grid
            container
            justify="center"
            md={8}
          >
            
              <p className="text-center mt-5" >
              <h4 className="pcc---section-main-heading">Tokenomics</h4>
              <img src={Aimage} className="img-fluid mb-3 left"  style={{width: '12%',display: 'block',
    marginLeft: 'auto'}} />
                
              <p>• 10,000,000,000 tokens are in total supply, all of which are in open circulation. </p><br></br>

              <p>• 4.5% of all transactions go to liquidity. </p><br></br>

<p>• 4.5% of all transactions are given as BNB Rewards. Half of these rewards go to holders and the rest to the maintenance wallet.4.5% of all transactions are given as BNB Rewards. Half of 
these rewards go to holders and the rest to the maintenance 
wallet.</p><br></br>

<p>• 1% of all transactions are provided as pCatV3 rewards to 
holders.</p><br></br>

<p>• 100 BNB Presale on Unicrypt. </p><br></br>

<p>• 80% of presale funds go to liquidity.</p><br></br>

<p>• No team tokens.</p><br></br>

<p>• No marketing tokens.</p><br></br>

<p>• Community built.</p><br></br>

<p>• Anti-Whale so that no one dumps like safe moon. Above certain % or moving between two wallets have 2 bnb tax.</p><br></br>

<p>• Low buy and sell fees.</p><br></br>

<p>• PCatV3 operates on Binance Smart Chain, transaction fees are ranged within 4c to 24 cents.</p><br></br>

<p>• Lightning fast transaction speeds. Average transaction time on BSC is 3 seconds!</p><br></br>
<img src={Dimage} className="img-fluid mb-3 left"  style={{width: '12%',display: 'block',
    marginRight: 'auto'}} />
              </p>
              
          </Grid>
        </Grid>
      </Container>
    </div>
  );
}

export default Discussionbody;


